import reducer from "./reducer";
export { default as TypesOfSkillsTransversal } from "./components/index";
export { default as typesOfSkillsTransversalReducerName } from "./constants";
export default reducer;
